export function getPrefix(hasPrefix: boolean): string {
  return hasPrefix ? 'от' : '';
}
